import { forwardRef } from 'react';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import TextEditor, { ForwardedAttrs } from './TextEditor';
import { Props as TextEditorProps } from './TextEditorInner/TextEditorInner';

export type Props = {
  currentUser: AuthUserType;
} & TextEditorProps;

const TextEditorWithContext = forwardRef<ForwardedAttrs, Props>(
  ({ currentUser, ...props }, ref) => {
    return (
      <AuthProvider currentUser={currentUser}>
        <TextEditor ref={ref} {...props} />
        <ToastComponent />
      </AuthProvider>
    );
  }
);

TextEditorWithContext.displayName = 'TextEditorWithContext';

export default TextEditorWithContext;
